import React from 'react';
import random from '~/utils/random';

class Audio extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.markSoundStatus !== nextProps.markSoundStatus || this.props.disableSound !== nextProps.disableSound) {
      return true;
    }
    return false;
  }

  componentDidUpdate() {
    if (this.props.loop > 0 && this.audioRef) {
      this.audioRef.contentWindow.location.replace(`/audio.html?var=${random.float() * 1000}`);
    }
  }

  onLoad(loop) {
    const url = this.audioRef.contentWindow.location.href;
    if (url === 'about:blank') {
      return;
    }
    const soundTime = setTimeout(() => {
      if (this.audioRef) {
        this.audioRef.contentWindow.location.replace('about:blank');
      }
      clearTimeout(soundTime);
    }, loop * 2950);
  }

  render() {
    const {loop} = this.props;
    return loop && loop > 0 ? (
      <iframe
        style={{display: 'none'}}
        allow='autoplay'
        title='sound'
        onLoad={this.onLoad.bind(this, loop)}
        ref={(r) => {
          this.audioRef = r;
        }}
      />
    ) : (
      ''
    );
  }
}

export default Audio;
